<template>
    <!-- الصفحة الرئيسية دائمًا موجودة -->
    <NuxtPage />
  
    <!-- طبقة الـ Loader فوق الصفحة الرئيسية -->
    <!-- <div
      v-if="showLoader"
      :class="['loader-placeholder', { finish: loaderFinished }]"
      @animationend="onAnimationEnd"
    >
    <div class="theme_tail_circle">
            <img class="logo-image" :src="'/website/assets/img/icon-logo.png'">

            <span>
              جاري التحميل ...
            </span>

        </div>
    </div> -->
  </template>
  
  <script setup lang="ts">
  import { ref, computed, watch, onBeforeMount } from 'vue'
  import { useWebsiteStore } from '~/store/website'
  
  const websiteStore = useWebsiteStore()
  
  // حالة عرض الـ Loader
  const showLoader = ref(true)
  // حالة تشغيل أنيميشن الانتهاء
  const loaderFinished = ref(false)
  
  // جلب البيانات أثناء الـ SSR/BeforeMount
  onBeforeMount(async () => {
    if (!websiteStore.initializationData) {
        await websiteStore.fetchInitializationData()
    }else{
        nextTick(() => {
        loaderFinished.value = true;
        });
       websiteStore.fetchInitializationData()
    }


  
  })

  const route = useRoute()

  useHead( {
    titleTemplate: ( titleChunk ) => {
      return titleChunk ? `${ titleChunk } | رفيو المنصة الأولى في التقييم و معرفة تجارب الآخرين و الاستفادة منها` : '| رفيو المنصة الأولى في التقييم و معرفة تجارب الآخرين و الاستفادة منها'
    },
    meta: [
      { property: 'og:title', content: `${route.meta.title} | رفيو` },
      { property: 'twitter:title', content: `${route.meta.title} | رفيو` },
    ]
  } )


  // الخاصية المحسوبة بتعكس حالة جلب البيانات (للاستخدام في المنطق إن احتجت)
  const hasData = computed(() => !!websiteStore.initializationData)
  
    // عند توفر البيانات نبدأ أنيميشن الانتهاء (إذا لم يكن قد حدث ذلك بالفعل)
    watch(hasData, (newVal) => {
    if (newVal && !loaderFinished.value) {
        // استخدام nextTick للتأكد من تطبيق التغييرات بعد تحديث الـ DOM
        nextTick(() => {
        loaderFinished.value = true;
        });
    }
    });
    
  // عند انتهاء الأنيميشن يتم إزالة طبقة الـ Loader
  function onAnimationEnd() {
    if (loaderFinished.value) {
      showLoader.value = false
    }
  }
  </script>
  
  <style scoped>
  .loader-placeholder {
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0.5);
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000; /* لضمان ظهورها فوق باقي المحتوى */
  }

  .logo-image {
    max-width: 80px;
    margin-bottom: 1rem;
  }
  
  /* حركة تكبير وتصغير متكررة */
  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.1); /* يمكنك التعديل على قيمة التكبير */
    }
    100% {
      transform: scale(1);
    }
  }
  
  .logo {
    max-width: 100px;
    animation: pulse 2s infinite ease-in-out; /* مدة الحركة 2 ثوانٍ وتعمل بشكل متكرر */
  }
  
  /* أنيميشن لتصغير اللوجو */
  @keyframes logoShrink {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: scale(1);
      opacity: 0;
    }
  }
  
  /* أنيميشن لتلاشي الخلفية البيضاء */
  @keyframes fadeOutBackground {
    0% {
      background-color: rgba(0,0,0,0.5);
    }
    100% {
      background-color: transparent;
    }
  }
  
  /* عند تفعيل الحالة النهائية */
  .loader-placeholder.finish {
    animation: fadeOutBackground 0.5s forwards;
  }
  
  .loader-placeholder.finish .theme_tail_circle {
    animation: logoShrink 0.5s forwards;
  }



    .theme_tail_circle {
      width: 130px;
    height: 160px;
    display: flex
;
    justify-content: center;
    align-items: center;
    background: #fff;
    border-radius: 12px;
    flex-direction: column;
    }

    .theme_tail_circle > span {
      font-size: 15px;
      direction: rtl;
      color: #6f7480;
    }

    .theme_tail_circle .pace_activity {
        border-radius: 50%;
        width: 40px;
        height: 40px;
        border: 3px solid rgba(0, 0, 0, .1);
        border-right-color: #fff;
        -webkit-animation: rotation 1.1s infinite linear;
        -o-animation: rotation 1.1s infinite linear;
        animation: rotation 1.1s infinite linear;
    }

    @-webkit-keyframes rotation {
        0% {
            -webkit-transform: rotate(0)
        }

        100% {
            -webkit-transform: rotate(360deg)
        }
    }

    @-moz-keyframes rotation {
        0% {
            -moz-transform: rotate(0)
        }

        100% {
            -moz-transform: rotate(360deg)
        }
    }

    @-ms-keyframes rotation {
        0% {
            -ms-transform: rotate(0)
        }

        100% {
            -ms-transform: rotate(360deg)
        }
    }

    @-o-keyframes rotation {
        0% {
            -o-transform: rotate(0)
        }

        100% {
            -o-transform: rotate(360deg)
        }
    }

    @keyframes rotation {
        0% {
            transform: rotate(0)
        }

        100% {
            transform: rotate(360deg)
        }
    }

    @-webkit-keyframes rotation_reverse {
        0% {
            -webkit-transform: rotate(0)
        }

        100% {
            -webkit-transform: rotate(-360deg)
        }
    }

  </style>
  